import React from 'react'
import styles from './Footer.module.scss'

const Footer = () => (
    <footer className ={styles.footer}>
        <div className={styles.container}>
            <span className="text-muted"> FPL Alerts 2020</span><a rel="me" href="https://mstdn.party/@fpl_alerts"> M</a>
        </div>
    </footer>
)

export default Footer;
